import React, { ChangeEvent, useState } from "react";
import { QuestionInput } from "../../../../../__generated__/gql-types/globalTypes";
import { Col, Row, Select } from "antd";
import { ErrorMessage, Field } from "formik";
import styles from "../../quizzForm.module.css";
import { UploadImageFile } from "../../../../UploadFile";
import { AnswersDiagramPartsComponent } from "./AnswersDiagramParts";

interface DiagramPartsQuestionProps {
  question: QuestionInput;
  index: number;
  loadingLoadImage: boolean;
  urlImageQuestion: string;
  urlImageAnswers: string[];
  imageAnswers: string[];
  handleRemoveAnswer: () => void;
  handleAddAnswer: () => Promise<void>;
  handleImageQuestion: (newImage: string) => void;
  handleImageAnswers: (newImage: string, indexAnswer: number) => void;
  setLoadingLoadImage: React.Dispatch<React.SetStateAction<boolean>>;
  setUrlImageQuestion: React.Dispatch<React.SetStateAction<string>>;
  setUrlImageAnswers: React.Dispatch<React.SetStateAction<string[]>>;
  setimageAnswers: React.Dispatch<React.SetStateAction<string[]>>;
  handleChange: (
    e: React.ChangeEvent<HTMLInputElement>,
    index?: number
  ) => void;
}

export const DiagramPartsQuestion = ({
  question,
  index,
  loadingLoadImage,
  urlImageQuestion,
  imageAnswers,
  urlImageAnswers,
  handleAddAnswer,
  handleRemoveAnswer,
  handleImageQuestion,
  setLoadingLoadImage,
  setUrlImageQuestion,
  setimageAnswers,
  setUrlImageAnswers,
  handleImageAnswers,
  handleChange,
}: DiagramPartsQuestionProps) => {
  return (
    <div>
      <Col
        key={`${index}_${new Date()}`}
        style={{
          backgroundColor: "#E6E7EF",
          borderRadius: 20,
          paddingRight: 30,
          paddingLeft: 30,
          paddingTop: 10,
        }}
      >
        <div style={{ marginBottom: 10, marginTop: 5 }}>
          <label htmlFor={`questions_${index}`}>Pregunta {index}</label>
        </div>
        <Row>
          <Field
            id={`questions_${index}`}
            name="question"
            type="text"
            component="textarea"
            rows="10"
            className={styles.formFieldSelect}
            defaultValue={question?.question ?? ""}
            onChange={(event: ChangeEvent<HTMLInputElement>) => {
              handleChange(event, index);
            }}
          />
          <ErrorMessage
            name="question"
            component="div"
            className={styles.error}
          />
        </Row>
        <Row>
          <UploadImageFile
            title={`Imagen de pregunta ${index}`}
            className={styles.uploadFile}
            questionTypeId={question.type_id}
            typeFile="questions"
            folder="questions"
            widthCover={300}
            heightCover={200}
            index={index}
            image={question.image ?? ""}
            loadingLoadImage={loadingLoadImage}
            setLoadingLoadImage={setLoadingLoadImage}
            urlImageQuestion={urlImageQuestion}
            handleImageQuestion={handleImageQuestion}
            setUrlImageQuestion={setUrlImageQuestion}
          />
        </Row>
        <AnswersDiagramPartsComponent
          handleChange={handleChange}
          question={question}
          handleAddAnswer={handleAddAnswer}
          handleRemoveAnswer={handleRemoveAnswer}
          imageAnswers={imageAnswers}
          setimageAnswers={setimageAnswers}
          urlImageAnswers={urlImageAnswers}
          setUrlImageAnswers={setUrlImageAnswers}
          handleImageAnswers={handleImageAnswers}
        />
      </Col>
    </div>
  );
};
